import React from 'react';
import * as ReactDOM from "react-dom";
import Game from "../Game";
import {withRouter} from "../withRouter";
import {NavLink} from "react-router-dom";
import {format} from "react-string-format";
import {Col, Container, Row} from "react-bootstrap";
import Subscriptions from "../Subscribe/Subscriptions";
import GameChats from "../Chat/GameChats";

class AdminHome extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            isLoadedData: false,
            error: null,
            adminData: [],
            userId: null,
            loginError: null,
        };
    }

    loadAdmin(){
        fetch(process.env.REACT_APP_API_URL + "/admin/" + this.state.userId.toString(), {
            headers: {'Content-Type': 'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoadedData: true,
                        adminData: result
                    });
                },

                (error) => {
                    this.setState({
                        isLoadedData: true,
                        error
                    });
                }
            )
    }

    componentDidMount() {
        fetch(process.env.REACT_APP_API_URL + '/my-account/try-login-via-cache', {
            method: "POST",
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        }).then(res => res.json())
            .then(
                (result) => {
                    if (result.role.name !== 'admin') {
                        this.setState({
                            isLoaded: true,
                            loginError: 'unauthorized'
                        });
                    } else {
                        this.setState({
                            isLoaded: true,
                            userId: result.id
                        }, this.loadAdmin);
                    }
                },
                (error) => {
                    this.setState({
                        isLoaded: false,
                        loginError: "unauthorized",
                    });
                }
            );
    }

    inviteModerator(e){
        e.preventDefault();

        const body = {'administrator_email': this.state.adminData.administrator_email, 'moderator_email': e.target.moderator_email.value};
        console.log(body);

        fetch(format(process.env.REACT_APP_API_URL + '/admin/{0}/moderators', this.state.userId.toString()), {
            method: "POST",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`},
        }).then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoadedData: true,
                        adminData: result
                    });
                },

                (error) => {
                    this.setState({
                        isLoadedData: true,
                        error
                    });
                }
            )
    }

    removeModerator(e){
        e.preventDefault();

        const body = {'administrator_email': this.state.adminData.administrator_email, 'moderator_email': e.target.moderator_email.value};
        console.log(body);

        fetch(format(process.env.REACT_APP_API_URL + '/admin/{0}/moderators', this.state.userId.toString()), {
            method: "DELETE",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`},
        }).then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoadedData: true,
                        adminData: result
                    });
                },

                (error) => {
                    this.setState({
                        isLoadedData: true,
                        error
                    });
                }
            )
    }

    render() {
        const { isLoaded, isLoadedData, adminData, loginError} = this.state;

        const { navigate } = this.props;

        if (loginError) {
            navigate('/account');
        }

        let content = null;

        if (isLoaded && isLoadedData) {
            content = <div>
                <section style={{backgroundColor: "#eee"}}>
                    <div className="container py-5">
                        <div className="row">
                            <div className="col">
                                <nav aria-label="breadcrumb" className="bg-light rounded-3 p-3 mb-4">
                                    <ol className="breadcrumb mb-0">
                                        <li className="breadcrumb-item active" aria-current="page">User Profile</li>
                                        <li className="breadcrumb-item">
                                            <a href="/account">
                                                <button type="button" className="btn btn-primary">Personal info</button>
                                            </a>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <a href={"/admin/"+this.state.adminData.id.toString()+"/settings"}>
                                                <button type="button" className="btn btn-primary">Settings</button>
                                            </a>
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-4">
                                <div className="card mb-4">
                                    <div className="card-body text-center">
                                        <img
                                            src={"https://cdn-icons-png.flaticon.com/512/2416/2416668.png"}
                                            alt="avatar"
                                            className="rounded-circle img-fluid" style={{width: '150px;'}}/>
                                        <div className="d-flex justify-content-center mb-2">
                                            <a href="/admin/payouts">
                                                <button type="button" className="btn btn-primary">Manage payouts
                                                </button>
                                            </a>
                                            <a href="/admin/company-revenue">
                                                <button type="button" className="btn btn-outline-primary ms-1">Company revenue
                                                </button>
                                            </a>
                                            <a href="/moderator">
                                                <button type="button" className="btn btn-primary ms-1">Moderators stats
                                                </button>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="card mb-4 mb-lg-0">
                                        <div className="card-body p-0">
                                            <ul className="list-group list-group-flush rounded-3">
                                    <h4>Invite moderators</h4>
                                    <form onSubmit={this.inviteModerator.bind(this)}>
                                        <input class="form-control" type="email" name="moderator_email"/>
                                        <input class="btn btn-danger ms-1" type="submit" value="Send invite"/>
                                    </form>
                                                <br/>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8">
                                <div className="card mb-4">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-sm-3">
                                                <p className="mb-0">Email</p>
                                            </div>
                                            <div className="col-sm-9">
                                                <p className="text-muted mb-0">{adminData.administrator_email}</p>
                                            </div>
                                        </div>
                                        <hr/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="card mb-4 mb-md-0">
                                            <div className="card-body">
                                                        <table className="table table-striped table-hover">
                                                            <caption>List of your moderators</caption>
                                                            <thead className="thead-light">
                                                            <tr>
                                                                <th scope="col">Email</th>
                                                                <th scope="col">Action</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            {adminData.moderators ? adminData.moderators.map(item => (
                                                                <tr id={item}>
                                                                    <th scope="row">{item}</th>
                                                                    <td>
                                                                        <form onSubmit={this.removeModerator.bind(this)}>
                                                                            <input hidden value={item} className="form-control" type="email"
                                                                                   name="moderator_email"/>

                                                                            <input class="btn btn-outline-danger" type="submit" value="Deactivate"/>
                                                                        </form>
                                                                    </td>
                                                                </tr>
                                                            )) : <tr>Empty</tr>}
                                                            </tbody>
                                                        </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>;
        } else {
            content = <h1>Loading...</h1>
        }

        return <Container>
            <Row>
                <Col>
                    {content}
                </Col>
            </Row>
        </Container>

    }
}

export default withRouter(AdminHome);
